module.exports = __webpack_public_path__ + "assets/img/img.fc5bc475.png";